import styled, { css } from 'styled-components'
import mq from 'styles/mq'

export const ProgressBarBackdrop = styled.div`
  background-color: #e0e0de;
  border-radius: 50px;

  ${mq.extraSmall} {
    height: 0.5rem;
    min-width: 15rem;
    margin: 1rem 2rem;
  }

  ${mq.small} {
    min-width: 20rem;
  }

  ${mq.medium} {
    height: 1rem;
    margin: 2rem 4rem;
  }
`

export const ProgressBarFiller = styled.div<{ bgColor: any; percentCompleted: number}>`
  height: 100%;
  border-radius: inherit;
  text-align: right;

  ${props =>
    props.bgColor && props.percentCompleted &&
    css`
      width: ${props.percentCompleted}%;
      background-color: ${props.bgColor};
    `}
`

export const ProgressBarLabel = styled.h5`
  text-transform: capitalize;
  text-align: right;
  margin-bottom: 0;

  ${mq.extraSmall} {
    min-width: 4rem;
  }
`

export const ProgressBarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ProgressBarScore = styled.h5`
  min-width: 2rem;
  margin-bottom: 0;
`